import { render, staticRenderFns } from "./deliverDialog.vue?vue&type=template&id=49988a40&scoped=true"
import script from "./deliverDialog.vue?vue&type=script&lang=js"
export * from "./deliverDialog.vue?vue&type=script&lang=js"
import style0 from "./deliverDialog.vue?vue&type=style&index=0&id=49988a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49988a40",
  null
  
)

export default component.exports